import envConfig from '../../static/config';
import {
  handleSuccessReponsePaymentHistoryList,
  handleErrorReponsePaymentHistoryList,
  handleSuccessReponsePaymentStatusList,
} from '../actions/PaymentStatusActionCreator';
import ApiUtils from './ApiUtils';

const _getPaymentHistoryListUrl =
  '/ibapi/v2/banks/{bank-id}/accounts/default/paymenthistory/searches';
const _getPaymentStatusUrl =
  '/content/FateOfPayments/error_messages_latest.json';

export const getPaymentHistoryList = (requestData) => {
  const url = envConfig.apiBaseUrlPAAS + _getPaymentHistoryListUrl;
  ApiUtils.makeAjaxCall(
    {
      apiVersion: '1.3.0',
      method: 'POST',
      url,
      addAuthToken: true,
      requestData,
    },
    (body) => {
      handleSuccessReponsePaymentHistoryList(body);
    },
    (error, status) => {
      handleErrorReponsePaymentHistoryList(error.error, status);
    }
  );
};
export const getPaymentStatusList = () => {
  fetch(envConfig.staticContentWebAppLink + _getPaymentStatusUrl, {
    method: 'GET',
  })
    .then((res) => res.json())
    .then((res) => handleSuccessReponsePaymentStatusList(res));
};
